import { useEffect, useState } from 'react';

import { PrimaryWhiteButton } from '../../../components/Button/Buttons';
import { ActionRow, Muted, NoteInput, Row, Section, SectionTitle } from '../../../components/Detail/DetailParts';
import useTransactionReceipts from '../../../hooks/dashboard/receipts/useTransactionReceipts';
import { tableFormatDateTimeNG } from '../../../utils/utils';

// A purchase's receipts: number, kind, when issued, how often checked, and
// Withdraw with a reason (limits spec R7, D27).
const ReceiptsSection: React.FC<{ transactionId: string }> = ({ transactionId }) => {
  const { receipts, withdrawing, fetchReceipts, withdraw } = useTransactionReceipts();
  const [open, setOpen] = useState<string | null>(null);
  const [reason, setReason] = useState('');

  useEffect(() => {
    fetchReceipts(transactionId);
    // eslint-disable-next-line
  }, [transactionId]);

  if (!receipts.length) return null;
  return (
    <Section>
      <SectionTitle>Receipts</SectionTitle>
      {receipts.map((r) => (
        <div key={r.id}>
          <Row label={r.kind === 'BILL' ? 'Bill receipt' : 'Payment receipt'}>{r.number}</Row>
          <Muted>
            Issued {tableFormatDateTimeNG(r.issued_at)} · checked {r.times_verified} time{r.times_verified === 1 ? '' : 's'}
            {r.withdrawn_at ? ` · withdrawn ${tableFormatDateTimeNG(r.withdrawn_at)} by ${r.withdrawn_by}: ${r.withdraw_reason}` : ''}
          </Muted>
          {!r.withdrawn_at &&
            (open === r.id ? (
              <>
                <NoteInput rows={2} placeholder='Why withdraw it? (10+ characters)' value={reason} onChange={(e) => setReason(e.target.value)} />
                <ActionRow>
                  <PrimaryWhiteButton
                    type='button'
                    disabled={withdrawing || reason.trim().length < 10}
                    onClick={() => {
                      withdraw(transactionId, r.id, reason.trim());
                      setOpen(null);
                      setReason('');
                    }}
                  >
                    Withdraw receipt
                  </PrimaryWhiteButton>
                  <PrimaryWhiteButton type='button' onClick={() => setOpen(null)}>
                    Cancel
                  </PrimaryWhiteButton>
                </ActionRow>
              </>
            ) : (
              <ActionRow>
                <PrimaryWhiteButton type='button' onClick={() => setOpen(r.id)}>
                  Withdraw…
                </PrimaryWhiteButton>
              </ActionRow>
            ))}
        </div>
      ))}
    </Section>
  );
};

export default ReceiptsSection;
